/**
 * @module events/options/once
 */

/**
 * @type {boolean}
 */
export default true
